import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import { ThrowNotFound } from 'src/components/not-found';
import { PageSpinner } from 'src/components/spinner-container';
import { useOrganisationService } from 'src/pages/settings/organisation/use-organisation-service';
import { UsersOverview } from 'src/pages/settings/organisation/users';
import { UserDetails } from 'src/pages/settings/organisation/users/details';
import { EditUser } from 'src/pages/settings/organisation/users/details/edit';
import { UpgradeToAdmin } from 'src/pages/settings/organisation/users/details/upgrade-to-admin';
import { InviteUser } from 'src/pages/settings/organisation/users/invite';
import { InviteUserSuccess } from 'src/pages/settings/organisation/users/invite/success';

export const OrganisationManagement: FC = () => {
  const organisationService = useOrganisationService();

  if (!organisationService.response) return <PageSpinner />;

  return (
    <Switch>
      <Route path="/settings/organisation/users" exact>
        <UsersOverview organisationService={organisationService} />
      </Route>

      <Route path="/settings/organisation/users/invite" exact>
        <InviteUser organisationService={organisationService} />
      </Route>

      <Route path="/settings/organisation/users/invite/success" exact>
        <InviteUserSuccess />
      </Route>

      <Route path="/settings/organisation/users/:userId" exact>
        <UserDetails organisationService={organisationService} />
      </Route>

      <Route path="/settings/organisation/users/:userId/edit" exact>
        <EditUser organisationService={organisationService} />
      </Route>

      <Route path="/settings/organisation/users/:userId/upgrade-to-admin" exact>
        <UpgradeToAdmin organisationService={organisationService} />
      </Route>

      <Route>
        <ThrowNotFound />
      </Route>
    </Switch>
  );
};
